import type { MigrationStrategies } from "./_types/migration-strategies";

export const DISEASE_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
  3: (oldDoc) => {
    delete oldDoc.code;
    delete oldDoc.coding;
    return oldDoc;
  },
};
